import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Lightweight loading placeholder. Use freely while data is loading
 * instead of a bare "Loading…" string.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-[color:var(--kz-color-surface-sunken)]',
        className,
      )}
      {...props}
    />
  );
}
